//function neveshte shode tavasot mamad...(bullshit)
import moment from 'moment-jalaali'
export function cal_dis(s, e, x = 0) {
  let toRadians = (degrees) => (degrees * Math.PI) / 180;
  let latFrom = toRadians(s[0]);
  let lonFrom = toRadians(s[1]);
  let latTo = toRadians(e[0]);
  let lonTo = toRadians(e[1]);

  let latDelta = latTo - latFrom;
  let lonDelta = lonTo - lonFrom;

  let a =
    Math.sin(latDelta / 2) * Math.sin(latDelta / 2) +
    Math.cos(latFrom) *
      Math.cos(latTo) *
      Math.sin(lonDelta / 2) *
      Math.sin(lonDelta / 2);
  let d = 12742 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  if (x === 1) return d;
  if (d <= 0.5) d =  (parseInt(d * 20) * 50 + 50) + "-متر";
  else if (d <= 1) d =  (parseInt(d * 10) * 100 + 100) + "-متر";
  else if (d <= 10)
    d =  (parseInt(parseInt(d * 20) / 10) / 2 + 0.5) + "-کیلومتر";
  else d =  (parseInt(d) + 1) + "-کیلومتر";
  return d;
}


export const convertDate=(date)=>{
  return moment.unix(parseInt(date)).format("jYYYY/jM/jD----hh:mm:ss a")
}